/**
 * Mock-mode registry.
 *
 * <p>Originally each domain had a typed mock adapter behind the same TypeScript contract as the
 * real API so the FE could be demoed offline. As the real backend filled in, mocks became
 * shadow-of-truth and started drifting. **Default is now real API.** Mocks are an explicit
 * opt-in (`VITE_USE_MOCKS=true`) reserved for offline screenshots / story-mode runs.
 *
 * Production builds keep mocks off (unchanged). Local `npm run dev` now hits `/api/v1/*`
 * directly via the Vite proxy — fail loudly when a real endpoint is missing so we implement
 * it rather than mock around it.
 */
export const MOCKS_ENABLED =
  (import.meta.env.VITE_USE_MOCKS as string | undefined) === "true";

/** Stable random for the same seed — used for mock data variation. */
export function seededRandom(seed: number): () => number {
  let value = seed;
  return () => {
    value = (value * 9301 + 49297) % 233280;
    return value / 233280;
  };
}

/** Simulate a small network delay so loading states are visible. */
export function delay<T>(value: T, ms = 250): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}
